import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import PortalVacantesContainer from './PortalVacantesContainer';
import reportWebVitals from './reportWebVitals';
import Login from "./ComponentesGenerales/Login";
import Router from "./Router";

ReactDOM.render(
  <React.StrictMode>
      <Router />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
